import { render, staticRenderFns } from "./loanOrder.vue?vue&type=template&id=2afd76aa&scoped=true"
import script from "./loanOrder.vue?vue&type=script&lang=js"
export * from "./loanOrder.vue?vue&type=script&lang=js"
import style0 from "./loanOrder.vue?vue&type=style&index=0&id=2afd76aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afd76aa",
  null
  
)

export default component.exports